<template>
  <div class="detail">
    <div
      class="coupon-code"
      v-if="couponResponse && couponResponse.length"
      v-for="coupon in couponResponse"
    >
      <div class="left-part">
        <p><strong>Rs {{coupon.discountedAmount}}/- OFF</strong> on Min Order <strong>Rs {{coupon.minimumOrderAmount}}</strong>.<br />Valid only for <strong v-if="coupon.paymentMethod === 'COD'">COD Payments</strong>
          <strong v-else-if="coupon.paymentMethod === 'ONLINE'">Online Payments</strong>
          <strong v-else>TODAY</strong>!
        </p>
      </div>
      <div class="right-part flx">
        <p>
          <input
            type="text"
            :value="coupon.couponCode"
            readonly
            :id="coupon.couponCode"
          />
          <br /><span>User Code</span>
        </p>
        <span
          class="icon"
          @click="copyTestingCode(coupon.couponCode)"
        >
          <CopyIcon />
        </span>
      </div>
    </div>
    <section class="product_detail_page">
      <div class="request_header hid">
        <div class="flx">
          <div class="back_arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="16"
              viewBox="0 0 20 16"
              @click="goBack()"
            >
              <g
                fill="#505050"
                fill-rule="evenodd"
              >
                <path
                  fill="#505050"
                  fill-rule="nonzero"
                  stroke="#505050"
                  stroke-width="0.05"
                  d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
                />
                <path
                  fill="#505050"
                  fill-rule="nonzero"
                  stroke="#505050"
                  stroke-width="0.05"
                  d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
                />
              </g>
            </svg>
          </div>
          <div class="thumbimage_wrapper">
            <span
              class="thumbnail_image"
              v-if="allDetails.itemMediaDTOList && allDetails.itemMediaDTOList.length > 0"
            >
              <img
                class="image__item"
                :src="allDetails.itemMediaDTOList[0].thumbnail"
                alt="random image"
              />
            </span>
            <span
              class="thumbnail_image"
              v-else
            >
              <img
                class="image__item"
                src="../assets/images/watermark1.jpg"
                alt="random image"
              />
            </span>
          </div>
          <div
            class="icon_wrapper"
            style="justify-content: flex-end;"
          >
            <span
              class="tabIcon"
              @click="shareFunc(allDetails.shareMessageUrl,allDetails.itemMediaDTOList[0].original, allDetails.sellerItemRelationshipId)"
              v-if="$cookie.get('version-code')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 30 28"
              >
                <path
                  fill="green"
                  stroke="green"
                  d="M25.2 19.2c-1.371.003-2.655.675-3.438 1.8L9 14.268c.043-.333.043-.67 0-1.002l12.72-6.714c1.232 1.826 3.666 2.39 5.575 1.292 1.91-1.098 2.647-3.485 1.688-5.469C28.025.392 25.696-.514 23.65.3c-2.047.815-3.117 3.072-2.451 5.172l-12.57 6.6C7.83 10.252 5.865 9.24 3.92 9.647 1.975 10.055.581 11.77.581 13.758c0 1.988 1.394 3.703 3.339 4.11 1.945.408 3.91-.604 4.708-2.424l12.564 6.6c-.588 1.725.003 3.632 1.463 4.722 1.46 1.09 3.457 1.114 4.943.06 1.486-1.055 2.122-2.948 1.576-4.686-.547-1.738-2.152-2.926-3.974-2.94zm0-18c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zM4.8 16.8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879zm20.4 9.6c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
                />
              </svg>
            </span>
            <span
              class="tabIcon"
              :class="{'added' : addToCartCountAction}"
              @click="goToCart()"
              v-if="$cookie.get('JWT-TOKEN')"
            >
              <span
                class="one-cart-size"
                v-if="cartSize > 0"
              >{{cartSize}}</span>
              <span class="add-no">{{cartSize}}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="20"
                viewBox="0 0 21 26"
              >
                <g>
                  <path
                    fill="#505050"
                    d="M20.986 21.44L19.804 6.81c-.074-.943-.886-1.681-1.849-1.681H15.62v-.103C15.62 2.255 13.323 0 10.5 0S5.381 2.255 5.381 5.026v.103H3.045c-.963 0-1.775.738-1.848 1.679L.014 21.443c-.092 1.172.322 2.338 1.135 3.2C1.963 25.505 3.116 26 4.313 26h12.374c1.197 0 2.35-.495 3.164-1.357.813-.862 1.227-2.028 1.135-3.202zM6.932 5.027c0-1.932 1.6-3.503 3.568-3.503 1.967 0 3.568 1.571 3.568 3.503v.103H6.932v-.103zm11.78 18.582c-.528.56-1.247.87-2.025.87H4.313c-.778 0-1.497-.31-2.025-.87-.529-.56-.787-1.288-.728-2.047L2.743 6.926c.012-.154.145-.274.302-.274h2.336v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h7.136v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h2.336c.157 0 .29.12.302.276L19.44 21.56c.06.761-.199 1.49-.727 2.05z"
                  />
                </g>
              </svg>
            </span>
            <!-- </router-link> -->

            <!-- <span
              class="tabIcon"
              :class="{'active' : isBookMark == false}"
              @click="bookMark(allDetails.saleReferenceID,isBookMark)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17">
                <path
                  fill="#505050"
                  fill-rule="evenodd"
                  d="M11.433 14.328V2.52a.829.829 0 0 0-.816-.84H2.45a.829.829 0 0 0-.817.84v11.808l4.426-3.252a.798.798 0 0 1 .949 0l4.425 3.252zm-4.9-1.536l-5.242 3.852c-.54.397-1.291 0-1.291-.684V2.52C0 1.128 1.097 0 2.45 0h8.167c1.353 0 2.45 1.128 2.45 2.52v13.44c0 .683-.751 1.08-1.292.684l-5.242-3.852z"
                />
              </svg>
            </span> -->
          </div>
        </div>

        <div class="sticky_detail_tab flx">
          <span
            class="detail_tab_name"
            @click="ChangeTab(1)"
            :class="getClass(1)"
          >
            <a
              href="#div-detailtab"
              v-smooth-scroll="{updateHistory: false}"
            >{{$t('productDetail')}}</a>
          </span>
          <span
            class="rating_tab_name"
            @click="ChangeTab(2)"
            :class="getClass(2)"
          >
            <a
              href="#div-rating"
              v-smooth-scroll="{updateHistory: false}"
            >{{$t('feedback')}}</a>
          </span>
          <span
            class="related_prdt_name"
            @click="ChangeTab(2)"
            :class="getClass(2)"
          >
            <a
              href="#div-relatedprouct"
              v-smooth-scroll="{updateHistory: false}"
            >{{$t('relatedProduct')}}</a>
          </span>
        </div>
      </div>
      <ImageSlider
        :dataValue="allDetails"
        :viewerCount="viewCount"
        :productAddedAction="addToCartCountAction"
        :productAdded="addToCartCount"
        @notLoggedInUser="checkUserIsLogin"
      />
      <div>
        <ProductDetailTab
          :dataValue="allDetails"
          @ENABLACUTPRICE="ENABLACUTPRICE"
          :dataStyleAmount="finalPaidAmountCut"
          id="div-detailtab"
          :dataAvgRating="avgRatingValue"
          :dataValueInStock="inStockValue"
          @getDiscountDetail="getProductDetail"
          @getProductAdded="funcProductAdded"
          :itemAddedValue="hotDealAdded"
          @getUserLocationCallBack="getUserLocation"
          @updatedPrice='updatePriceValue'
          @setNewDetailValue="setAgainNewdetailvalue"
          @notLoggedInUser="checkUserIsLogin"
        />
        <ProductFeedbackTab
          :ratingDetails="ratingList"
          :saleReferenceId="allDetails.sellerItemRelationshipId"
          id="div-rating"
        />

        <RelatedProduct
          :dataValue="recommendedProductList"
          :title="$t('relatedProduct')"
          :merchantId="categoryId"
          id="div-relatedprouct"
          @notLoggedInUser="checkUserIsLogin"
        />
      </div>
    </section>
    <div
      id="cart-snackbar"
      :class="{'show': addToCartCountAction}"
    >
      <div
        class="flx"
        style="font-size: 1.5em;"
      >
        <p>{{$t('itemAddedTocart')}}</p>
        <p
          style="color:#f93"
          @click="goToCart()"
        >{{$t('goToCart')}}</p>
        <!-- <router-link :to="{path:'/cart-check-out'}" tag="p" style="color:#f93">{{$t('goToCart')}}</router-link> -->
      </div>
    </div>
    <div
      class="loader"
      v-if="loading"
    >
      <img
        src="../assets/images/loader.gif"
        alt="loader"
      />
    </div>
    <CustomToaster
      :dataValue="toasterData"
      v-if="isToasterData"
    />
    <div id="hotItemAdded">{{$t('itemAddedTocart')}}</div>
    <div
      id="cart-snackbar"
      :class="{'show': showNoLocationBar}"
    >
      <div
        class="flx"
        style="justify-content:center"
      >
        <p>Please Switch on Your App Location</p>
      </div>
    </div>
    <login-form
      v-if="isLogedInUser"
      @notLoggedInUser="checkUserIsLogin"
    />
  </div>
</template>

<script>
import CopyIcon from "@/components/Icons/CopyIcon";
import YoutubeIcon from "@/components/Icons/YoutubeIcon";
import "../assets/css/product-detail.scss";
import "../assets/css/home-style.scss";
import ImageSlider from "../components/ProductDetailSection/ImageSlider";
import ProductDetailTab from "../components/ProductDetailSection/ProductDetailTab";
import ProductFeedbackTab from "../components/ProductDetailSection/ProductFeedbackTab";
import RelatedProduct from "../components/HomeSection/RelatedProduct";
import vueSmoothScroll from "vue2-smooth-scroll";
import { mapGetters, mapState } from "vuex";
import CustomToaster from "../components/Common/CustomToaster";
import types from "../store/types";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import LoginForm from "@/components/ShopManagementSection/LoginForm";
import Vue from "vue";
Vue.use(vueSmoothScroll);
export default {
  name: "ProductDetail",
  components: {
    ImageSlider,
    ProductDetailTab,
    ProductFeedbackTab,
    RelatedProduct,
    CustomToaster,
    CopyIcon,
    YoutubeIcon,
    LoginForm,
  },
  data() {
    return {
      inStockValue: false,
      saleReferenceID: null,
      loading: false,
      details: [],
      allDetails: {},
      productDtlSpan: true,
      ProductDtlLikeSpan: false,
      ProductDtlCmntSpan: false,
      selectedFilterType: "",
      viewCount: "0",
      categoryId: null,
      recommendedProductList: [],
      orderSourceType: null,
      finalPaidAmountCut: false,
      isBookMark: true,
      thumbnailImage: false,
      ratingList: {},
      ratingIndex: 0,
      ratingLimit: 10,
      avgRatingValue: {},
      addToCartCount: 0,
      addToCartCountAction: false,
      productOfTheDayList: [],
      hotDealAdded: false,
      toasterData: {},
      isToasterData: false,
      couponDisplayResponse: {},
      showNoLocationBar: false,
      timerId: null,
      isLogedInUser: false,
    };
  },
  computed: {
    ...mapGetters(["cartSize", "couponResponse"]),
  },
  methods: {
    checkUserIsLogin() {
      this.$emit("notLoggedInUser");
    },
    goToCart() {
      if (this.$cookie.get("JWT-TOKEN")) {
        if (this.$route.query.shopid) {
          this.$router.push(
            "/cart-check-out" + "?shopid=" + this.$route.query.shopid
          );
        } else {
          this.$router.push("/cart-check-out");
        }
      } else {
        this.$emit("notLoggedInUser");
      }
    },
    updatePriceValue(obj) {
      this.allDetails = obj;
    },
    getPromoCodeList() {
      this.blankLoad = true;
      ApiCaller(
        constant.COUPON_API_URL,
        "get-coupons-for-application/200",
        "get"
      )
        .then((data) => {
          this.$store.commit(
            types.COUPON_RESPONSE,
            data.data.couponDisplayResponseDTOs[0]
          );
        })
        .catch((err) => {});
    },
    copyTestingCode(whatsappNumber) {
      let el = document.getElementById(whatsappNumber);
      el.select();
      document.execCommand("copy");
    },
    funcProductAdded() {
      this.addToCartCountAction = !this.addToCartCountAction;
      setTimeout(() => {
        this.addToCartCountAction = !this.addToCartCountAction;
      }, 3000);
    },
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    shareFunc(shareMessage, shareImage, saleReferenceID) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        try {
          JSBridgePlugin.fireEvents("Detail_Page_Product_Shared");
        } catch (err) {
          console.log(err);
        }
        this.loading = true;
        ApiCaller(
          constant.LOCAL_SHOP_URL,
          `get-share-details/${saleReferenceID}?type=ITEM`,
          "get"
        )
          .then((data) => {
            this.shareLinkData = data.data;
            this.loading = false;
            shareMessage = data.data.shareMessage;
            const obj = {
              message: shareMessage,
              imageUrl: shareImage,
            };
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              window.open("whatsapp://send?text=" + shareMessage);
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
          });
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
    bookMark(productId, isBookMark) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        try {
          if (this.isBookMark) {
            this.isBookMark = false;
          } else {
            this.isBookMark = true;
          }
          JSBridgePlugin.bookmarkProduct(Number(productId), isBookMark);
        } catch (err) {
          console.log(err);
        }
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
    getClass(type) {
      if (this.selectedFilterType == type) {
        return "active";
      }
    },
    ChangeTab(value) {
      this.selectedFilterType = value;
      if (value == 1) {
        this.productDtlSpan = true;
        this.ProductDtlLikeSpan = false;
        this.ProductDtlCmntSpan = false;
      } else if (value == 2) {
        this.productDtlSpan = false;
        this.ProductDtlLikeSpan = false;
        this.ProductDtlCmntSpan = true;
      }
      // else {
      //   this.productDtlSpan = false;
      //   this.ProductDtlLikeSpan = false;
      //   this.ProductDtlCmntSpan = true;
      // }
    },
    ENABLACUTPRICE(cuttheprice_boolean) {
      this.getProductDetail(cuttheprice_boolean);
    },
    setAgainNewdetailvalue(value) {
      this.allDetails = value;
    },
    getProductDetail(lat, long) {
      this.$data.saleReferenceID = this.$route.params.saleReferenceID;
      this.loading = true;
      if (this.$route.query.source === "ADS_SERVER") {
        this.orderSourceType = this.$route.query.source;
      } else if (!this.$cookie.get("version-code")) {
        this.orderSourceType = "STORE_LOGIN";
      } else if (this.$route.query.source) {
        this.orderSourceType = this.$route.query.source;
      } else {
        this.orderSourceType = null;
      }
      const obj = {
        saleReferenceID: this.$route.params.saleReferenceID,
        referralUserId: this.$route.params.encodedId,
        orderSourceType: this.orderSourceType,
      };
      let payloadValue;
      if (lat && long) {
        if (this.$route.query.shopid) {
          payloadValue =
            this.$route.params.saleReferenceID +
            "?orderSourceType=" +
            this.orderSourceType +
            "&latitude=" +
            lat +
            "&longitude=" +
            long +
            "&shopid=" +
            this.$route.query.shopid;
        } else {
          payloadValue =
            this.$route.params.saleReferenceID +
            "?orderSourceType=" +
            this.orderSourceType +
            "&latitude=" +
            lat +
            "&longitude=" +
            long;
        }
      } else {
        if (this.$route.query.shopid) {
          payloadValue =
            this.$route.params.saleReferenceID +
            "?orderSourceType=" +
            this.orderSourceType +
            "&shopid=" +
            this.$route.query.shopid;
        } else {
          payloadValue =
            this.$route.params.saleReferenceID +
            "?orderSourceType=" +
            this.orderSourceType;
        }
      }

      this.$store
        .dispatch({
          type: "getProductDetail",
          payload: payloadValue,
        })
        .then((data) => {
          this.loading = false;
          this.allDetails = data.data.productListingDTO;
          this.details = data.data.itemMediaDTOList;
          this.viewCount = data.data.viewersCount;
          this.categoryId = this.allDetails.categoryId;
          this.inStockValue = data.data.productListingDTO.inStock;
          if (this.allDetails.categoryId) {
            this.getSalesListing();
          }
          if (data.data.itemCutPriceInfoDTO) {
            this.finalPaidAmountCut = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    getSalesListing() {
      this.categoryId = this.allDetails.categoryId;
      const obj = {
        pageIndex: 0,
        shopId: this.$route.query.shopid || null,
        categoryId: Number(this.allDetails.categoryId) || null,
        sortField: "ITEM_DATE",
        sortBy: "DESC",
        filters: [],
      };
      if (this.$route.query.source == "GMALL_FACTORY_PRODUCTS") {
        obj.filters.push(
          {
            filterField: "IS_LOCALSHOP_PRODUCTS",
            filterFieldValue: {
              value: true,
            },
          },
          {
            filterField: "INSTOCK",
            filterFieldValue: {
              value: true,
            },
          }
        );
      } else if (!Number(this.allDetails.categoryId)) {
        obj.filters.push(
          {
            filterField: "IS_RETAILSHOP_PRODUCTS",
            filterFieldValue: {
              value: true,
            },
          },
          {
            filterField: "INSTOCK",
            filterFieldValue: {
              value: true,
            },
          }
        );
      }
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        "localshop/get-products",
        "post",
        obj,
        "get"
      )
        .then((data) => {
          this.recommendedProductList = data.data.productListingDTOs;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRatings() {
      ApiCaller(
        "https://localmall.mall91.com/",
        `product/rating/reviews/${this.$route.params.saleReferenceID}/${this.ratingLimit}/${this.ratingIndex}`,
        "get"
      )
        .then((data) => {
          if (data.data) {
            this.ratingList = data.data;
            this.avgRatingValue = data.data;
          }
        })
        .catch((err) => {
          this.ratingList = [];
          console.log(err);
        });
    },
    getUserLocation() {
      try {
        _getLocation.requestLocation = (res) => {
          this.loading = false;
          console.log(res);
          if (res) {
            try {
              JSBridgePlugin.addCookiesOn(
                "https://localui.mall91.com/#/detail/" +
                  this.$route.params.saleReferenceID
              );
              setTimeout(() => {
                this.getProductDetail(
                  this.$cookie.get("latitude"),
                  this.$cookie.get("longitude")
                );
              }, 1000);
            } catch (err) {
              console.log(err);
            }
          } else {
            console.log("please switch on your location");
            this.showNoLocationBar = !this.showNoLocationBar;
            setTimeout(() => {
              this.showNoLocationBar = !this.showNoLocationBar;
            }, 3000);
          }
        };
        JSBridgePlugin.requestLocation(
          null,
          null,
          "_getLocation.requestLocation"
        );
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
  updated() {
    if (!this.$data.saleReferenceID == this.$route.params.saleReferenceID) {
      this.getProductDetail();
    }
  },
  mounted() {
    ApiCaller(constant.APP_SETTING_SERVICE_URL, "get-aap-settings", "get")
      .then((data) => {
        this.$store.commit("VIEW_TYPE", data.data[0].designStyle);
        console.log(this.$route.name);
        if (data.data[0].cloudShopUser) {
          if (this.$route.path == "/discount-kirana") {
            this.$store.commit("CLOUDSHOP_USER", false);
          } else {
            this.$store.commit("CLOUDSHOP_USER", data.data[0].cloudShopUser);
          }
        } else {
          this.$store.commit("CLOUDSHOP_USER", false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    this.$store.commit("noAddressCheck", false);
    this.$store.commit("savePreOrderDetail", {
      availablePreOrderData: null,
    });

    let [, , id] = window.location.pathname.split("/");
    let [, , saleRef] = this.$route.path.split("/");
    if (id) {
      if (window.location.pathname === `/dukaan/${id}/`) {
        this.$store
          .dispatch({
            type: "getDukaanQrUsers",
            payload: id,
          })
          .then((data) => {
            var xauthid = btoa(this.$cookie.get("X-Auth-Id"));
            if (data.data.userId) {
              window.location.href = `http://dukaan.money91.com/#/product-detail/${data.data.userId}/${saleRef}`;
            }
          })
          .catch((err) => {
            if (err) console.log("=-=err-=-", err);
          });
      }
    }
    if (this.$cookie.get("latitude") && this.$cookie.get("longitude")) {
      this.getProductDetail(
        this.$cookie.get("latitude"),
        this.$cookie.get("longitude")
      );
    } else {
      this.getProductDetail();
    }

    // this.getPromoCodeList()
    this.getRatings();
    let header = document.querySelector(".request_header");
    let activeDetailTab = document.querySelector(".detail_tab_name");
    let activeCommentTab = document.querySelector(".rating_tab_name");
    let activeRelatedTab = document.querySelector(".related_prdt_name");
    let detailSection =
      document.getElementById("div-detailtab").clientHeight + 318.4;
    let commentSection =
      document.getElementById("div-rating").clientHeight +
      detailSection +
      318.4;
    let totalHeight = Math.floor(detailSection + commentSection);
    window.onscroll = function () {
      scrollFunction();
    };
    function scrollFunction() {
      if (
        document.body.scrollTop > 218.4 ||
        document.documentElement.scrollTop > 218.4
      ) {
        header.classList.add("sticky");
        activeDetailTab.classList.add("detailactive");
      } else {
        header.classList.remove("sticky");
        activeDetailTab.classList.remove("detailactive");
      }
      if (
        document.body.scrollTop > detailSection ||
        document.documentElement.scrollTop > detailSection
      ) {
        activeDetailTab.classList.remove("detailactive");
        activeCommentTab.classList.add("ratingactive");
        activeRelatedTab.classList.remove("relatedprdtactive");
      } else {
        activeCommentTab.classList.remove("ratingactive");
      }
      if (
        document.body.scrollTop > commentSection ||
        document.documentElement.scrollTop > commentSection
      ) {
        activeDetailTab.classList.remove("detailactive");
        activeCommentTab.classList.remove("ratingactive");
        activeRelatedTab.classList.add("relatedprdtactive");
      } else {
        activeRelatedTab.classList.remove("relatedprdtactive");
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
    this.$store.commit("updateProdSizeIndex", null);
  },
};
</script>
<style lang="scss" scoped>
.coupon-code {
  background: #042d49;
  color: #fff;
  // font-weight: 600;
  padding: 8px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  animation: ak 0.2s 1;
  border-bottom: 1px solid #000;
  // animation-delay: 5s;
  .left-part {
    width: 60%;
    font-size: 0.75em;
  }
  .right-part {
    width: 40%;
    justify-content: flex-end;
    p {
      padding-right: 8px;
      font-size: 0.875em;
      text-align: right;
      input {
        background: none;
        // width: 49%;
        color: #fff;
        font-weight: 600;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        font-weight: normal;
        color: #a3aeb5;
        font-size: 0.75em;
        display: block;
      }
    }
    .icon {
      background: #a3aeb5;
      display: block;
      width: 35px;
      height: 24px;
      padding: 5px;
      border-radius: 50%;
      .st0 {
        fill: none;
        stroke: #fff;
        stroke-width: 2;
        stroke-miterlimit: 10;
      }
      .st1 {
        fill: none;
        stroke: #fff;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 4.11, 4.11;
      }
    }
  }
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
#hotItemAdded {
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 99;
  left: 50%;
  bottom: 30px;
  font-size: 17px;
}

#hotItemAdded.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
</style>